// Generated by ts-to-zod
import { z } from "zod";
import { TaxType } from "./TaxType.d";

export * from "./TaxType.d";

export const taxTypeSchema = z.nativeEnum(TaxType);
